import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { initializeLocale } from "./i18n.js";
import { restoreAccessSession } from "./services/api.js";
import { registerServiceWorker } from "./pwa/registerServiceWorker.js";
import { startPwaInstallPromptCapture } from "./pwa/installPrompt.js";
import "./tailwind-input.css";

/**
 * Restore the authenticated session before the application starts.
 *
 * The access token now lives only in memory, so a fresh JavaScript
 * context must first try the refresh cookie before any protected view
 * or profile-driven initialization runs.
 */
async function initializeAuthentication() {
  try {
    await restoreAccessSession();
  } catch (error) {
    // The router will decide later whether the current route can
    // continue unauthenticated or should redirect to login.
  }
}

async function bootstrapApp() {
  startPwaInstallPromptCapture();
  const serviceWorkerRegistration = registerServiceWorker();
  await initializeAuthentication();
  await initializeLocale();
  const app = createApp(App);
  app.use(router);
  await router.isReady();
  app.mount("#app");
  await serviceWorkerRegistration;
}

bootstrapApp();
